import { FORM } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchDeleteForm = async (formId) => {
  const method = "DELETE";

  const stored = JSON.parse(localStorage.getItem("logindata") || "{}");
  const token = stored?.data?.token || "";

  if (!token) {
    throw new Error("No hay token. Inicia sesión.");
  }

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const response = await ApiRequestInterceptor(
    `${FORM.deleteForm}/${formId}`,
    method,
    null,
    headers
  );

  if (response.code === 200) {
    return response;
  } else {
    const errorMessage = response?.data?.error || "Error desconocido";
    throw new Error(errorMessage);
  }
};
